import React, { useEffect, createRef } from "react";
import ImageCurve from "../../images/curve-shape-intro-section.svg";
import ImageMac from "../../images/dashboard-mac.png";
import ImageIpad from "../../images/dashboard-iPad.png";
import ImageMobile from "../../images/dashboard-iPhone.png";
import InView from "react-intersection-observer";
import lottie from 'lottie-web';
import animation from '../../icons/svg_animations/Path-Animation/PathAnimation.json';
import animation1 from '../../icons/svg_animations/Path-Animation/PathAnimation1.json';
import LazyLoad from 'react-lazyload';
import Parallax from '../common/utils/animations/parallax';
import { directions } from '../common/utils/animations/animationConstants';
//import AOS from 'aos';
import 'aos/dist/aos.css'
export default function Intro() {

  let animationContainer = createRef();
  let animationContainer1 = createRef();

  let AOS;

  useEffect(() => {
    const AOS = require("aos");
    AOS.init({
      once: true,
    });
    const anim = lottie.loadAnimation({
      container: animationContainer.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: animation
    });

    const anim1 = lottie.loadAnimation({
      container: animationContainer1.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: animation1
    });
  }, []);

  useEffect(() => {
    if (AOS) {
      AOS.refresh();
    }
  });

  return (
    <InView className="po-cs-dashboard-wrapper">
      <div className="animation1">
        <div className="animation1-wrapper">
          <div className="path-animation-container backside" ref={animationContainer1} />
        </div>
      </div>
      <div className="animation2">
        <div className="animation2-wrapper">
          <div className="path-animation-container" ref={animationContainer} />
        </div>
      </div>
      <div className="section-gap po-cs-dashboard-section">
          
          <div className="dashboard-inner row d-flex flex-wrap align-v-center">
              <div className="col left-image-dashboard">
                <Parallax classes="po-dashboard-image1" id="po-dashboard-image1" direction={directions.TTB} triggers={[1.2, 0.2]} length={150}><div data-aos="zoom-in-right" data-aos-delay="500"><LazyLoad offset={700}><img src={ImageMobile} title="Patient monitoring mobile applicaiton" alt="Patient monitoring mobile applicaiton" /></LazyLoad></div></Parallax>
                <Parallax classes="po-dashboard-image2" id="po-dashboard-image2" direction={directions.TTB} triggers={[1.2, 0.2]} length={150}><div data-aos="zoom-in-right" data-aos-delay="300"><LazyLoad offset={700}><img src={ImageIpad} title="Patient monitoring mobile applicaiton" alt="Patient monitoring mobile applicaiton" /></LazyLoad></div></Parallax>
                 
              </div>
              <div className="col right-image-dashboard">
                <Parallax classes="po-dashboard-image3" id="po-dashboard-image3" direction={directions.TTB} triggers={[1.2, 0.2]} length={150}><div data-aos="zoom-in-left" data-aos-delay="500"><LazyLoad offset={700}><img src={ImageMac} title="Patient monitoring platform" alt="Patient monitoring platform" /></LazyLoad></div>
              </Parallax>
              </div>
          </div>
      </div>
    </InView>
  );
}